import { useState, useEffect } from "react";

const getExternalIP = async () => {
  try {
    const response = await fetch("https://api64.ipify.org?format=json");
    const data = await response.json();
    // console.log("IP externo detectado:", data.ip);
    
    // Armazena o IP no localStorage para uso futuro
    localStorage.setItem("localIP", data.ip);
    
    return data.ip;
  } catch (error) {
    console.error("Erro ao obter IP externo:", error);
    return null;
  }
};

export const useLocalIP = () => {
  const [localIP, setLocalIP] = useState(localStorage.getItem("localIP") || null);

  useEffect(() => {
    if (!localIP) {
      getExternalIP().then((ip) => {
        if (ip) {
          setLocalIP(ip);
        }
      });
    }
  }, [localIP]);

  return localIP;
};
